/**
 * Mirrors Locsy Citizen home demo / feature card art
 * (`locsy_home_controls_grid.dart` + `career_zone_home_nav.dart`).
 * Used when Citizen Screens has no CMS `thumbnail_url` yet.
 */

const DEMO_CARDS = {
  food_zone: [
    {
      title: 'K Hotel Biryani',
      image:
        'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=640&q=80',
    },
    {
      title: 'Ramakrishna Currys',
      image:
        'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=640&q=80',
    },
    {
      title: 'Spice Route Tiffins',
      image:
        'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=640&q=80',
    },
  ],
  fresh_market: [
    {
      title: 'Farmers Market — Muskmelon',
      image:
        'https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=640&q=80',
    },
    {
      title: 'Green Veg Basket',
      image:
        'https://images.unsplash.com/photo-1542838132-92c53300491e?w=640&q=80',
    },
    {
      title: 'Dairy Fresh',
      image:
        'https://images.unsplash.com/photo-1550583724-b2692b85b150?w=640&q=80',
    },
  ],
  street_vendors: [
    {
      title: 'Live carts near you',
      image:
        'https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=640&q=80',
    },
    {
      title: 'Call or send your pin',
      image:
        'https://images.unsplash.com/photo-1542838132-92c53300491e?w=640&q=80',
    },
  ],
  learn_zone: [
    {
      title: 'Online Courses',
      image:
        'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=640&q=80',
    },
    {
      title: 'Campus Classes',
      image:
        'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=640&q=80',
    },
  ],
  health_updates: [
    {
      title: 'Free BP Camp — PHC',
      image:
        'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=640&q=80',
    },
    {
      title: 'Dr. Reddy Clinic',
      image:
        'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=640&q=80',
    },
    {
      title: 'Children Vaccination Day',
      image:
        'https://images.unsplash.com/photo-1584515933487-779824d29309?w=640&q=80',
    },
  ],
  local_2nd_market: [
    {
      title: 'iPhone 12 — Good Condition',
      image:
        'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=640&q=80',
    },
    {
      title: 'Sofa Set — Moving Sale',
      image:
        'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=640&q=80',
    },
    {
      title: 'Cycle for Student',
      image:
        'https://images.unsplash.com/photo-1576435728678-68d0fbf94e91?w=640&q=80',
    },
  ],
  real_estate: [
    {
      title: '2BHK Near Bus Stand',
      image:
        'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=640&q=80',
    },
    {
      title: 'Plot — Highway Facing',
      image:
        'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=640&q=80',
    },
    {
      title: 'Shop Space for Rent',
      image:
        'https://images.unsplash.com/photo-1497366216548-37526070297c?w=640&q=80',
    },
  ],
  jobs: [
    {
      title: 'Local Jobs',
      image:
        'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=640&q=80',
    },
    {
      title: 'Hire Staff',
      image:
        'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=640&q=80',
    },
    {
      title: "I'm Available",
      image:
        'https://images.unsplash.com/photo-1522075469751-3840a1d0e8d4?w=640&q=80',
    },
  ],
  career_zone: [
    {
      title: 'Local Jobs',
      image:
        'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=640&q=80',
    },
    {
      title: 'Hire Staff',
      image:
        'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=640&q=80',
    },
    {
      title: "I'm Available",
      image:
        'https://images.unsplash.com/photo-1522075469751-3840a1d0e8d4?w=640&q=80',
    },
  ],
  rentals: [
    {
      title: 'Scooty on Rent — Daily',
      image:
        'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=640&q=80',
    },
    {
      title: 'Wedding Chairs & Shamiana',
      image:
        'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=640&q=80',
    },
    {
      title: 'DSLR Camera Kit',
      image:
        'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=640&q=80',
    },
  ],
  religious: [
    {
      title: 'Temple Annadanam — Sunday',
      image:
        'https://images.unsplash.com/photo-1542810634-56a2cb58857d?w=640&q=80',
    },
    {
      title: 'Church Choir Practice',
      image:
        'https://images.unsplash.com/photo-1438239982991-995b54755d88?w=640&q=80',
    },
    {
      title: 'Gurudwara Langar Seva',
      image:
        'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=640&q=80',
    },
  ],
  govt_alerts: [
    {
      title: 'Power Cut Alert',
      image:
        'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=640&q=80',
    },
    {
      title: 'Tanker Schedule',
      image:
        'https://images.unsplash.com/photo-1548839140-29a74925bcbf?w=640&q=80',
    },
    {
      title: 'Ration Shop Holiday',
      image:
        'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=640&q=80',
    },
  ],
  movies_events: [
    {
      title: 'Cinema Night — Town Hall',
      image:
        'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=640&q=80',
    },
    {
      title: 'Live Folk Dance',
      image:
        'https://images.unsplash.com/photo-1501281668745-f7f57925c88b?w=640&q=80',
    },
    {
      title: 'Kids Drawing Competition',
      image:
        'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=640&q=80',
    },
  ],
  digital_pamphlets: [
    {
      title: 'Local brochure',
      image:
        'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=640&q=80',
    },
    {
      title: 'Shop offers',
      image:
        'https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=640&q=80',
    },
    {
      title: 'Festival flyer',
      image:
        'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=640&q=80',
    },
  ],
  citizen_posts: [
    {
      title: 'Local listing',
      image:
        'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=640&q=80',
    },
    {
      title: 'Neighbourhood request',
      image:
        'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=640&q=80',
    },
    {
      title: 'Community update',
      image:
        'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=640&q=80',
    },
  ],
};

const GENERIC = [
  {
    title: 'Local update',
    image:
      'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=640&q=80',
  },
];

export function getAppDemoCards(sectionKey) {
  const key = String(sectionKey || '').trim();
  return DEMO_CARDS[key] || GENERIC;
}

/** Cover for admin cards: CMS → locsy_sections default → first app demo. */
export function resolveSectionCoverUrl(section) {
  const cms = String(section?.thumbnail_url || '').trim();
  if (cms) return { url: cms, source: 'cms' };
  const app = String(section?.app_default_image_url || '').trim();
  if (app) return { url: app, source: 'app' };
  const demo = getAppDemoCards(section?.section_key)[0]?.image || '';
  if (demo) return { url: demo, source: 'demo' };
  return { url: '', source: 'none' };
}

/** Cards shown in phone preview (CMS cover replaces first demo when set). */
export function getPreviewCarouselCards(section) {
  const demos = getAppDemoCards(section?.section_key).slice(0, 3);
  const cms = String(section?.thumbnail_url || '').trim();
  const app = String(section?.app_default_image_url || '').trim();
  const cover = cms || app;
  if (!cover || demos.length === 0) return demos;
  return [{ ...demos[0], image: cover, title: section?.title || demos[0].title }, ...demos.slice(1)];
}

/**
 * Flat library for “search & pick” cover dialog.
 * Includes app demos, locsy_sections defaults, and existing CMS covers.
 */
export function listCoverPickCandidates(sections = []) {
  const seen = new Set();
  const out = [];

  const push = (item) => {
    const url = String(item?.url || '').trim();
    if (!url || seen.has(url)) return;
    seen.add(url);
    out.push(item);
  };

  for (const [sectionKey, cards] of Object.entries(DEMO_CARDS)) {
    cards.forEach((card, idx) => {
      push({
        id: `demo:${sectionKey}:${idx}`,
        url: card.image,
        title: card.title,
        sectionKey,
        source: 'demo',
        label: `App demo · ${sectionKey}`,
      });
    });
  }

  GENERIC.forEach((card, idx) => {
    push({
      id: `demo:generic:${idx}`,
      url: card.image,
      title: card.title,
      sectionKey: 'generic',
      source: 'demo',
      label: 'App demo · generic',
    });
  });

  (sections || []).forEach((s) => {
    const key = String(s?.section_key || '').trim();
    const title = String(s?.title || key || 'Section').trim();
    const app = String(s?.app_default_image_url || '').trim();
    if (app) {
      push({
        id: `app:${s.id}`,
        url: app,
        title: `${title} default`,
        sectionKey: key,
        source: 'app',
        label: `App default · ${title}`,
      });
    }
    const cms = String(s?.thumbnail_url || '').trim();
    if (cms) {
      push({
        id: `cms:${s.id}`,
        url: cms,
        title: `${title} cover`,
        sectionKey: key,
        source: 'cms',
        label: `CMS cover · ${title}`,
      });
    }
  });

  return out;
}

export function filterCoverCandidates(candidates, query) {
  const q = String(query || '')
    .trim()
    .toLowerCase();
  if (!q) return candidates;
  return candidates.filter((c) => {
    const hay = [c.title, c.sectionKey, c.label, c.source, c.url]
      .map((x) => String(x || '').toLowerCase())
      .join(' ');
    return hay.includes(q);
  });
}
